import { TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'

function IPv4RangeInput(props) {
    const { onInputChange, value } = props;
    const initOctet = {
        first: '',
        second: '',
        third: '',
        fourth: '',
    };
    const [startOctet, setStartOctet] = React.useState(initOctet);
    const [endOctet, setEndOctet] = React.useState(initOctet);
    const [ipValue, setIPValue] = React.useState(value);

    const handleInputStartChange = (e) => {
        const { name, value } = e.target;
        const hasErrorSyntax = handleValidateChange(value, name, startOctet);
        if (hasErrorSyntax) {
            const newValue = { ...startOctet, [name]: value };
            setStartOctet(newValue);
            const newIPInput = {
                start: `${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`,
                end: `${endOctet.first}.${endOctet.second}.${endOctet.third}.${endOctet.fourth}`
            }
            setIPValue(newIPInput);
            onInputChange(newIPInput, validateRangeFormat(`${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`, `${endOctet.first}.${endOctet.second}.${endOctet.third}.${endOctet.fourth}`))
        }
    };

    const handleInputEndChange = (e) => {
        const { name, value } = e.target;
        const hasErrorSyntax = handleValidateChange(value, name, endOctet);
        if (hasErrorSyntax) {
            const newValue = { ...endOctet, [name]: value };
            setEndOctet(newValue);
            const newIPInput = {
                start: `${startOctet.first}.${startOctet.second}.${startOctet.third}.${startOctet.fourth}`,
                end: `${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`
            }
            setIPValue(newIPInput);
            onInputChange(newIPInput, validateRangeFormat(`${startOctet.first}.${startOctet.second}.${startOctet.third}.${startOctet.fourth}`, `${newValue.first}.${newValue.second}.${newValue.third}.${newValue.fourth}`))
        }
    };

    const handleValidateChange = (value, name, Octet) => {
        const newValue = { ...Octet };
        let isValid = false;
        if (value === "") {
            isValid = true;
        } else if (/^[0-9]+$/.test(value)) {
            // ถ้าเป็นตัวเลขล้วน ยอมรับ แต่ต้องตรวจสอบเพิ่มเติม: ไม่ให้กรณีฐาน value เริ่ม "*" แล้วมา paste ตัวเลข
            if (value !== "*") {
                isValid = true;
            }
        } else if (value === "*") {
            // ถ้า paste '*' เพียงตัวเดียว และเดิม value ว่างเปล่า => ยอมรับ
            if (newValue[name] === "") {
                isValid = true;
            }
        }
        // กรณีอื่นๆ ไม่ยอมรับ (เช่น "1*","*1","**","12*3" เป็นต้น)
        return isValid;
    };

    const validateRangeFormat = (ipStart, ipEnd) => { // รองรับการตรวจสอบ Class A,B,C
        const ip_start = validateFormat(ipStart);
        const ip_end = validateFormat(ipEnd);
        if (!ip_start || !ip_end) return false;
        const startNum = ipToNumber(ipStart);
        const endNum = ipToNumber(ipEnd);
        if (startNum > endNum) return false; // ตรวจสอบว่า IP เริ่มต้นไม่มากกว่า IP สิ้นสุด
        return true;
    };

    const validateFormat = (ip) => { // รองรับการตรวจสอบ Class A,B,C
        // แยกส่วนของ IP Address
        const segments = ip.split('.');
        if (segments.length !== 4) return false;

        const [firstOctet, ...rest] = segments;

        // ปฏิเสธหาก octet แรกเป็น '*'
        if (firstOctet === '*') return false;

        // ตรวจสอบว่าแต่ละ octet เป็นตัวเลขระหว่าง 0-255 หรือ '*'
        for (const segment of segments) {
            if (!/^\d+$/.test(segment)) return false;
            const num = Number(segment);
            if (num < 0 || num > 255) return false;
        }

        // ตรวจสอบว่า octet แรกอยู่ในช่วงของ Class A, B หรือ C
        const firstOctetNum = Number(firstOctet);
        if (
            (firstOctetNum >= 1 && firstOctetNum <= 126) || // Class A
            (firstOctetNum >= 128 && firstOctetNum <= 191) || // Class B
            (firstOctetNum >= 192 && firstOctetNum <= 223) // Class C
        ) {
            return true;
        }

        // หากไม่อยู่ในช่วงที่กำหนด ถือว่าไม่ถูกต้อง
        return false;
    };

    function ipToNumber(ip) {
        const segments = ip.split('.');
        if (segments.length !== 4) return NaN; // ตรวจสอบว่า IP Address มี 4 ส่วนหรือไม่
        const result = Number(segments.map(String).join(''));
        return result;
    }

    // const validateRangeFormat = (ipStart, ipEnd) => {
    //     const regex = /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
    //     if (!regex.test(ipStart) || !regex.test(ipEnd)) return false;
    //     return ipToNumber(ipStart) < ipToNumber(ipEnd);
    // };

    // function ipToNumber(ip) {
    //     return ip.split('.').reduce((acc, octet) => (acc << 8) + parseInt(octet, 10), 0);
    // }

    useEffect(() => {
        if (ipValue?.start !== props?.value?.start || ipValue?.end !== props?.value?.end) {
            setStartOctet(initOctet);
            setEndOctet(initOctet);
            setIPValue(null)
        }
    }, [props.value])

    return (
        <div className='flex flex-row gap-2 justify-center items-center'>
            <div className='flex flex-row gap-1 border border-gray-300 rounded-[5px] p-1.5 max-w-[220px]'>
                <TextField
                    name="first"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={startOctet.first}
                    onChange={(e) => {
                        handleInputStartChange(e)
                    }}
                />
                <Typography variant="subtitle2" className='flex items-center'>.</Typography>
                <TextField
                    name="second"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={startOctet.second}
                    onChange={(e) => {
                        handleInputStartChange(e)
                    }}
                />
                <Typography variant="subtitle2" className='flex items-center'>.</Typography>
                <TextField
                    name="third"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={startOctet.third}
                    onChange={(e) => {
                        handleInputStartChange(e)
                    }}
                />
                <Typography variant="subtitle2" className='flex items-center'>.</Typography>
                <TextField
                    name="fourth"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={startOctet.fourth}
                    onChange={(e) => {
                        handleInputStartChange(e)
                    }}
                />
            </div>
            <Typography variant='body1'>-</Typography>
            <div className='flex flex-row gap-1 border border-gray-300 rounded-[5px] p-1.5 max-w-[220px]'>
                <TextField
                    name="first"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={endOctet.first}
                    onChange={(e) => {
                        handleInputEndChange(e)
                    }}
                />
                <Typography variant="subtitle2" className='flex items-center'>.</Typography>
                <TextField
                    name="second"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={endOctet.second}
                    onChange={(e) => {
                        handleInputEndChange(e)
                    }}
                />
                <Typography variant="subtitle2" className='flex items-center'>.</Typography>
                <TextField
                    name="third"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={endOctet.third}
                    onChange={(e) => {
                        handleInputEndChange(e)
                    }}
                />
                <Typography variant="subtitle2" className='flex items-center'>.</Typography>
                <TextField
                    name="fourth"
                    variant="standard"
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ style: { textAlign: 'center', paddingBottom: 0 }, maxLength: 3 }}
                    value={endOctet.fourth}
                    onChange={(e) => {
                        handleInputEndChange(e)
                    }}
                />
            </div>
        </div>
    )
}

export default IPv4RangeInput